import React from 'react';
import { useTranslation } from 'react-i18next';
import { IMachine } from 'types/interfaces/iMachine';
import LastUpdated from '../../components/elements/LastUpdated';
import TooltipInfo from '../../components/TooltipInfo';
import { ContentWrapper } from '../../elements';
import withLoadingState from '../../helpers/withLoadingState';
import { ContainerTitle, PageHeader, PageHeaderTitle } from './elements';
import StatusOverview from './StatusOverview';

interface DashboardProps {
  machines: {
    [key: string]: IMachine[];
  };
}

const Dashboard: React.FC<DashboardProps> = ({ machines }) => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader alwaysVisible>
        <ContainerTitle>
          <PageHeaderTitle>{t('dashboard.title')}</PageHeaderTitle>
          <TooltipInfo titleTooltip="dashboard.title_tooltip" />
        </ContainerTitle>
        {machines && Object.keys(machines).length > 0 && <LastUpdated type="dashboard" marginBottom="0" />}
      </PageHeader>
      <ContentWrapper maxWidth={false}>
        <StatusOverview machines={machines} />
      </ContentWrapper>
    </>
  );
};

export default withLoadingState(Dashboard);
